type EventListener = (event: Event, trigger?: HTMLElement | undefined) => void;
type ElementWithListener = {
	element: HTMLElement;
	listener: EventListener;
};

export function initializeOpenElements(
	root: ParentNode | undefined,
	id: string,
	listener: EventListener
): ElementWithListener[] {
	return initializeClickElements(
		root,
		`[href="#${id}"], [data-target="#${id}"]`,
		listener
	);
}

export function initializeDismissElements(
	root: HTMLElement | undefined,
	listener: EventListener
): ElementWithListener[] {
	return initializeClickElements(root, '[data-dismiss]', listener);
}

export function initializeClickElements(
	root: ParentNode | undefined,
	query: string,
	listener: EventListener
): ElementWithListener[] {
	if (!root) {
		return [];
	}

	const elementsWithListener = Array.from(
		root.querySelectorAll<HTMLElement>(query)
	).map((element) => ({
		element,
		listener: (e: Event) => listener(e, element),
	}));

	addClickElements(elementsWithListener);

	return elementsWithListener;
}

export function addClickElements(elements: ElementWithListener[]): void {
	elements.forEach(({ element, listener }) =>
		element.addEventListener('click', listener)
	);
}

export function removeClickElements(elements: ElementWithListener[]): void {
	elements.forEach(({ element, listener }) =>
		element.removeEventListener('click', listener)
	);
}
